import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiEventActions = ActionsSet.make<DataKeys.KaapiEvents>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiEvents],
  cacheKey: DataKeys.KaapiEvents,
})

export const listKaapiEvents = kaapiEventActions.add(
  new ListAction<DataKeys.KaapiEvents, { namespace: string }>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to list Kaapi Events', { namespace })
    return kubernetes.getKaapiEvents()
  }),
)
